<script>
	import About from "./Components/About.svelte";
	import Education from "./Components/Education.svelte";
	import Nav from "./Components/Nav.svelte";
	import Banner from "./Components/Banner.svelte";
	import Resume from "./Components/Resume.svelte";
	import * as content from "./Constants";
	import Projects from "./Components/Projects.svelte";
	import Contact from "./Components/Contact.svelte";
	import Footer from "./Components/Footer.svelte";
	let height;
</script>

<svelte:window bind:innerHeight={height}></svelte:window>

{#each content.Images as image}
	<!-- <link rel="preload" href="images/{image}" as="image"> -->
{/each}

<header>
	<Nav content={content.NavItems}></Nav>	
	<Banner height={height} content={content.MainBanner} bind:scrollItem={content.NavItems[0]}></Banner>
</header>

<main>
	<About title={content.AboutTitle} content={content.About}></About>
	<Education title={content.EducationTitle} content={content.Education}></Education>
	<Resume id={"Experience"} title={content.ExperienceTitle} content={content.Resume}></Resume>
	<Resume id={"Research"} title={content.ReseachTitle} content={content.Research}></Resume>
	<Projects  title={content.ProjectsTitle} content={content.Projects}></Projects>
</main>

<footer>
	<Contact content={content.Contact}></Contact>
	<Footer content={content.Footer}></Footer>
</footer>

<style>
	footer {
		padding-top: 50px;
	}
</style>